export const supportedMediaTypes = ["image/*", "video/*"];
export const supportedMediaTypesWhatsapp = ["image/jpg","image/jpeg","image/png", "jpg", "jpeg", "png", "video/*"];

export const supportedFileTypes = [
  "text/*",
  // ".pdf",
  "application/pdf",
  // Excel files
  ".csv",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  // Word files
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  // PowerPoint files
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];
